import React from 'react';
import ToplearnText from './ToplearnText';
import { View, StyleSheet, Image, ScrollView,Platform } from 'react-native';
import { numberWithCommas } from '../../utils/price';

const TblShowDariaftha = ({
    shomarehFish,
    tarikhPardakht,
    mablaghKol,
    codVam,
    brdAdi,
    brdKargoshaie,
    brdZarori,
    brdTasvieh,
    brdBazprdkhtKomak,
    brdTavalod,
    brdHazinehJari,
    brdTozihat,
}) => {
    return (
        <View style={styles.tblShow}>
            <Image
                style={styles.imgProp}
                source={
                    brdBazprdkhtKomak !== 0
                        ? require('../../assets/info-sep.png')
                        : brdTavalod !== 0
                        ? require('../../assets/info-sep.png')
                        : brdTasvieh !== 0
                        ? require('../../assets/info-sep.png')
                        : brdZarori !== 0
                        ? require('../../assets/Zarori.png')
                        : brdKargoshaie !== 0
                        ? require('../../assets/Kargoshaie.png')
                        : require('../../assets/Adi.png')
                }
            />
            <View style={{ padding: 5 }}>
                <View style={styles.courseDetails}>
                    <ToplearnText fontFamily="yekan" size="1.5">
                        تاریخ دریافت: {tarikhPardakht}
                        {'   '}
                    </ToplearnText>
                    <ToplearnText fontFamily="yekan" size="1.5">
                        شماره فیش: {shomarehFish}
                    </ToplearnText>
                </View>

                <View style={styles.courseDetails}>
                    <ToplearnText fontFamily="yekan" size="1.5">
                        عادی:{' '}
                        {brdAdi === 0
                            ? ' -'
                            : ` ${numberWithCommas(brdAdi)} ریال`}
                        {'   '}
                    </ToplearnText>
                    <ToplearnText fontFamily="yekan" size="1.5">
                        کارگشایی:{' '}
                        {brdKargoshaie === 0
                            ? ' -'
                            : ` ${numberWithCommas(brdKargoshaie)} ریال`}
                    </ToplearnText>
                </View>
                <View style={styles.courseDetails}>
                    <ToplearnText fontFamily="yekan" size="1.5">
                        ضروری:{' '}
                        {brdZarori === 0
                            ? ' -'
                            : ` ${numberWithCommas(brdZarori)} ریال`}
                        {'   '}
                    </ToplearnText>
                    <ToplearnText fontFamily="yekan" size="1.5">
                        تسویه:{' '}
                        {brdTasvieh === 0
                            ? ' -'
                            : ` ${numberWithCommas(brdTasvieh)} ریال`}
                    </ToplearnText>
                </View>
                <View style={styles.courseDetails}>
                    <ToplearnText fontFamily="yekan" size="1.5">
                       ب.پ.کمک:{' '}
                        {brdBazprdkhtKomak === 0
                            ? ' -'
                            : ` ${numberWithCommas(brdBazprdkhtKomak)} ریال`}
                        {'   '}
                    </ToplearnText>

                    <ToplearnText fontFamily="yekan" size="1.5">
                        هدیه تولد:{' '}
                        {brdTavalod === 0
                            ? ' -'
                            : ` ${numberWithCommas(brdTavalod)} ریال`}
                    </ToplearnText>
                </View>
                <View style={styles.courseDetails}>
                    <ToplearnText fontFamily="yekan" size="1.5">
                        هزینه های جاری:{' '}
                        {brdHazinehJari === 0
                            ? ' -'
                            : ` ${numberWithCommas(brdHazinehJari)} ریال`}
                        {'   '}
                    </ToplearnText>
                </View>
                <View style={styles.courseDetails}>
                    <ToplearnText fontFamily="yekan" size="1.5">
                        توضیحات: {brdTozihat === 0 ? ' -' : brdTozihat}
                    </ToplearnText>
                </View>
            </View>
            <ToplearnText fontFamily="yekan" size="1.8" color="red">
                {mablaghKol === 0
                    ? ' -'
                    : ` ${numberWithCommas(mablaghKol)} ریال`}
            </ToplearnText>
        </View>
    );
};

export default TblShowDariaftha;

const styles = StyleSheet.create({
    tblShow: {
        alignSelf: 'center',
        borderRadius: 15,
        backgroundColor: 'white',
        marginBottom: 10,
        flexDirection: 'row',
        width: '95%',
        justifyContent: 'center',
        alignItems: 'center',
        padding: 5,
        justifyContent: 'space-evenly',
    },
    courseDetails: {
        flexDirection: 'row',
        //justifyContent: 'space-between',
    },
    imgProp: {
        width:Platform.OS === 'web' ? 40 : 30,
        height:Platform.OS === 'web' ? 40 : 30,
        resizeMode: 'contain',
    },
});
